import { array } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Billing, Service } from 'webapp-types';

import joinClasses from 'webapp/helpers/join-classes';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import FormRadiobuttonComponent from 'webapp/components/form/radiobutton';

export interface Args {
	model: Billing.ServiceInfo | null;
	selected: Billing.ServiceInfo | null;
	onChange: (option: Billing.ServiceInfo | null) => void;
}

const NO_SERVICE = 'no-service';

export default class AccountBillingServicesOptionComponent extends Component<Args> {
	@service('popup') declare popupService: Service.Popup;

	get modelId() {
		return this.args.model ? this.args.model.id : NO_SERVICE;
	}

	get selectedId() {
		return this.args.selected ? this.args.selected.id : NO_SERVICE;
	}

	get isSelected() {
		return this.modelId === this.selectedId;
	}

	get optionClass() {
		return `account-billing-services-option-${this.modelId}`;
	}

	@action
	selectOption() {
		this.args.onChange(this.args.model);
	}

	<template>
		<div
			class={{joinClasses
				(array
					"account-billing-services-option"
					this.optionClass
					(if this.isSelected "selected")
				)
			}}
		>
			<div role="button" class="option-click" {{on "click" this.selectOption}}></div>
			<div class="option-content">
				<div class="radio radiobutton-default">
					<FormRadiobuttonComponent
						@name="onboardingOption"
						@selected={{this.selectedId}}
						@value={{this.modelId}}
						@label=""
						@onChange={{this.selectOption}}
					/>
				</div>
				{{#if @model}}
					<CommonUiIconComponent @name={{@model.icon}} @size="xl" />
					{{#if @model.price}}
						<span class="price">{{@model.priceFormatted}}</span>
					{{else}}
						<div class="free-tag"></div>
					{{/if}}

					<p>
						<strong class="title">{{@model.name}}</strong>
						{{{@model.description}}}
					</p>

				{{else}}

					<strong class="title">I don’t need any service right now</strong>

				{{/if}}

			</div>
		</div>
	</template>
}
